/*
 * Utils
 *
 * Deliberately small. The replicated website's Utils carries moment,
 * google-libphonenumber, geocoding and a decade of accumulated helpers; this
 * project needs six functions, so it takes six rather than inheriting three
 * dependencies it would never otherwise install.
 */

const Utils = {
  debounce: (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(null, args), wait);
    };
  },
  // Matched to the replicated website's breakpoint so the two properties
  // agree about what a phone is.
  isMobile: () => {
    return window.innerWidth < 767.98;
  },
  // Formats to (555) 123-4567 for US-shaped numbers and otherwise returns the
  // input untouched. The full libphonenumber parse is not worth 500kb here.
  formatPhoneNumber: value => {
    let digits = String(value || '').replace(/[^0-9]/g, '');
    if (digits.length === 11 && digits.startsWith('1')) {
      digits = digits.slice(1);
    }
    if (digits.length !== 10) {
      return value;
    }
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  },
  scrollToTop: () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0
    });
  },
  truncateText: (text, maxLength) => {
    if (!text || text.length <= maxLength) {
      return text;
    }
    return `${text.substring(0, maxLength)}...`;
  },
  ucFirst: text => {
    return text ? text.charAt(0).toUpperCase() + text.substring(1) : '';
  },
  validateEmail: email => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
};
export default Utils;